//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { useListableProperties } from '@/api/legacy/useListableProperties';
import ClickOutside from '@/directives/ClickOutside';
import { searchProperty } from '@/helpers/util';

export default {
  name: 'DpGridMenu',
  directives: {
    ClickOutside,
  },
  props: {
    visible: { type: Boolean, default: false },
    settings: { type: Object, default: () => ({}) },
    columns: { type: Array, default: () => [] },
    columnOptions: { type: Object, default: () => ({}) },
  },
  setup() {
    const { listableProperties } = useListableProperties();
    return { listableProperties };
  },
  data() {
    return {
      filterString: '',
    };
  },
  computed: {
    filteredProperties() {
      return this.listableProperties.filter((p) => {
        if (p.isOnline) return false;

        if (this.settings && this.settings.hiddenProperties) {
          const hidden = this.settings.hiddenProperties || [];
          if (hidden.indexOf(p.name) > -1) {
            return false;
          }
        }
        return searchProperty(p, this.filterString);
      });
    },
  },
  watch: {
    visible(isVisible) {
      this.updatePosition();

      setTimeout(() => {
        if (isVisible) {
          document.querySelector('#app-root').appendChild(this.$refs.dropdown);
        } else {
          if (!this.$refs.dropdown) return;
          document.querySelector('#app-root').removeChild(this.$refs.dropdown);
        }
      }, 100);
    },
  },
  mounted() {
    this.updatePosition();
  },
  beforeDestroy() {
    if (this.visible) {
      document.querySelector('#app-root').removeChild(this.$refs.dropdown);
    }
  },
  methods: {
    isActive(prop) {
      let active = false;
      this.columns.forEach((c) => {
        if (c.name === prop.name && (c.visible === undefined || c.visible)) {
          active = true;
        }
      });
      return active;
    },
    updatePosition() {
      if (!this.$refs.anchor) return;

      const { anchor } = this.$refs;
      const width = 235;
      const containerPos = anchor.getBoundingClientRect();
      const yPos = containerPos.top + containerPos.height;

      this.$refs.dropdown.style.top = `${yPos}px`;
      this.$refs.dropdown.style.left = `${containerPos.left - width}px`;
    },
    selectProperty(prop) {
      this.$emit('toggle-column', prop);
    },
    hide() {
      this.$emit('close');
    },
    exportAsCsv() {
      this.$emit('export-as-csv');
    },
  },
};
